"use client";

import React from "react";
import { Building2, Handshake, Mail, Server, Layers3 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const contactOptions = [{
  title: "Enterprise deployment",
  description: "Discuss larger rollouts, custom implementation needs, support expectations, and deployment fit.",
  icon: Building2,
  subject: "Enterprise Deployment Inquiry"
}, {
  title: "Agency and reseller fit",
  description: "Discuss white-label structure, commercial fit, and how EloRAG supports multi-client delivery models.",
  icon: Handshake,
  subject: "Agency and Reseller Inquiry"
}, {
  title: "Technical architecture",
  description: "Review retrieval boundaries, governance controls, BYO-Key structure, and platform implementation questions.",
  icon: Server,
  subject: "Technical Architecture Inquiry"
}];
export default function TalkToSales() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="talk-to-sales" className="py-16 bg-background">
      <div className="container mx-auto px-6 max-w-7xl">
        <div ref={headerRef} className={cn("text-center max-w-3xl mx-auto mb-12 transition-all duration-700 ease-out", isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <div className="mb-5 inline-flex items-center gap-2 rounded-full bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
            <Layers3 className="size-4" />
            Talk to sales
          </div>

          <h2 className="text-3xl md:text-4xl font-bold text-foreground tracking-tight">
            Reach the right team faster
          </h2>

          <p className="mt-4 text-lg text-muted-foreground">
            For more specific questions, contact the team that best fits your deployment, reseller model, or technical review.
          </p>
        </div>

        <div ref={gridRef} className={cn("grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-700 delay-200 ease-out", isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          {contactOptions.map((option, i) => {
          const Icon = option.icon;
          return <Card key={i} data-index={i} className="h-full flex flex-col border-border shadow-sm hover:shadow-md transition-shadow duration-300 bg-card">
                <CardHeader className="pb-6">
                  <div className="size-12 rounded-lg bg-primary/10 flex items-center justify-center mb-6 text-primary">
                    <Icon className="size-6" />
                  </div>
                  <CardTitle className="text-xl mb-2">{option.title}</CardTitle>
                  <CardDescription className="text-base leading-relaxed">
                    {option.description}
                  </CardDescription>
                </CardHeader>

                <CardFooter className="mt-auto pt-6 border-t border-border/50">
                  <Button asChild variant="outline" className="w-full group">
                    <Link to={`mailto:contact@elorag.com?subject=${encodeURIComponent(option.subject)}`}>
                      <Mail className="mr-2 size-4 text-muted-foreground group-hover:text-primary transition-colors" />
                      Email Sales
                    </Link>
                  </Button>
                </CardFooter>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}